/**
 * @generated SignedSource<<91d6451c94728963c92581dbe0239144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditHolidaysGroupForm_account$data = {
  readonly allHolidaysGroups: ReadonlyArray<{
    readonly id: number;
    readonly name: string;
  }>;
  readonly " $fragmentType": "EditHolidaysGroupForm_account";
};
export type EditHolidaysGroupForm_account$key = {
  readonly " $data"?: EditHolidaysGroupForm_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditHolidaysGroupForm_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditHolidaysGroupForm_account",
  "selections": [
    {
      "alias": "allHolidaysGroups",
      "args": null,
      "concreteType": "holidays_groups",
      "kind": "LinkedField",
      "name": "holidays_groups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "1feb075f3998c91a04403e467d43b403";

export default node;
